export interface AsyncODataFieldProps {
  odataUrl?: string;

  // Base URL for OData endpoint (for schema-driven fields)
  baseODataUrl?: string;
  suffixODataUrl?: string;

  // OData key/path (for schema-driven fields)
  oDataKey?: string;

  // Method to retrieve the auth request header.
  // This is required.
  getAuthRequestHeader?: () => Promise<Record<string, string> | undefined>;

  // The column name used for the display value in the dropdown as well as the default column to search on.
  //
  // Default value: "label"
  textColumnName?: string;

  // The column name used for the value of the selected item in the dropdown.
  //
  // Default value: "value"
  valueColumnName?: string;

  // Whether the value is multiple.
  //
  // Default value: `false`
  isValueMultiple?: boolean;

  // Whether the value is required.
}

export const resolveODataUrl = (props: AsyncODataFieldProps): string => {
  if (props.odataUrl) {
    return props.odataUrl;
  }

  if (props.baseODataUrl && props.oDataKey && props.suffixODataUrl) {
    return `${props.baseODataUrl}/${props.oDataKey}/${props.suffixODataUrl}`;
  }

  if (props.baseODataUrl && props.oDataKey) {
    return `${props.baseODataUrl}/${props.oDataKey}`;
  }

  throw new Error("odataUrl is required");
};
